import {
  Exclude, Expose, Type,
} from 'class-transformer';
import { Catalogue } from './catalogue';

@Exclude()
export class CataloguesResponse {
  @Expose()
  totalCount: number;

  @Expose()
  @Type(() => Catalogue)
  catalogues: Catalogue[];
}
